import React from "react";
import { useFormContext } from "react-hook-form";
import { HotelFormData } from "./ManageHotelForm";

const ImagesSection = () => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext<HotelFormData>();

  const existingImageUrls = watch("imageUrls") || [];

  // Handle the deletion of images
  const handleDelete = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    imageUrl: string
  ) => {
    event.preventDefault();

    // Revoke the object URL to clean up
    URL.revokeObjectURL(imageUrl);

    // Remove the image from the state
    const updatedImageUrls = existingImageUrls.filter((url) => url !== imageUrl);
    setValue("imageUrls", updatedImageUrls);
  };

  // Handle file uploads
  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) return;

    // Create URLs for the selected files
    const newUrls = Array.from(files).map((file) => URL.createObjectURL(file));

    // Combine existing URLs with new ones, limiting the total to 6
    const updatedImageUrls = [
      ...existingImageUrls,
      ...newUrls
    ].slice(0, 6);

    setValue("imageUrls", updatedImageUrls);
  };

  return (
    <div className="p-4 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-4 text-center uppercase">Images</h2>
      <p className="text-sm mb-4 text-center text-red-500 uppercase">Add 6 Images</p>
      <hr className="border-gray-200 w-10/12 mx-auto mb-10" />
      <div className="flex flex-col gap-4">
        {existingImageUrls.length > 0 && (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {existingImageUrls.map((url) => (
              <div key={url} className="relative group">
                <img
                  loading="lazy"
                  src={url}
                  alt="Uploaded"
                  className="w-full h-32 object-cover rounded-md border border-gray-300"
                />
                <button
                  onClick={(event) => handleDelete(event, url)}
                  className="absolute top-2 right-2 bg-red-600 hover:bg-red-800 text-white rounded-full p-1.5 text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity"
                  aria-label="Delete"
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
        )}

        <label className="flex flex-col items-center p-4 border border-gray-300 rounded-lg bg-gray-100 cursor-pointer hover:bg-gray-200 transition-colors">
          <span className="text-gray-700 text-sm mb-5 uppercase">Upload Images</span>
          <input
            type="file"
            multiple
            accept="image/*"
            className="hidden"
            {...register("imageFiles", {
              onChange: handleUpload,
            })}
          />
          <span className="text-halo-pink text-sm">Select files</span>
        </label>
      </div>
      {errors.imageFiles && (
        <span className="text-red-500 text-sm font-bold mt-2 block">
          {errors.imageFiles.message}
        </span>
      )}
    </div>
  );
};

export default ImagesSection;